import {
    VRCORE_GET_COMPANY_POLICY,
    VRCORE_UPLOAD_POLICY,
    VRCORE_REMOVE_POLICY
} from "./types";
import firebase from "firebase/app";
import "firebase/storage";
import "firebase/auth";
import { push } from "connected-react-router";
export const getUploadedFiles = () => {
    return dispatch => {
        dispatch({
            type: VRCORE_GET_COMPANY_POLICY.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: VRCORE_GET_COMPANY_POLICY.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("collections/company_policy")
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_COMPANY_POLICY.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: VRCORE_GET_COMPANY_POLICY.FAIL
            });
        }
    };
};
export const gotolink = url => {
    return dispatch => {
        dispatch(push(url));
    };
};
export const uploadFile = (file, uploaded, callback) => {
    return dispatch => {
        dispatch({
            type: VRCORE_UPLOAD_POLICY.REQUEST
        });
        try {
            let task = firebase
                .storage()
                .ref(`company_policy/`)
                .child(file.name)
                .put(file);
            task.on(
                "state_changed",
                function(snapshot) {
                    // Observe state change events such as progress, pause, and resume
                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

                    let progress =
                        (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                    callback({
                        inProgress: true,
                        finished: false,
                        error: false,
                        progress: progress,
                        msg: "Upload is " + progress + "% done"
                    });
                },
                error => {
                    console.error(error);
                    // Handle unsuccessful uploads
                    callback({
                        inProgress: false,
                        finished: false,
                        error: true,
                        msg: "Something went wrong with this upload!"
                    });
                },
                () => {
                    // Handle successful uploads on complete
                    // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                    task.snapshot.ref.getDownloadURL().then(function(url) {
                        let files = {
                            file: file.name,
                            fileURL: url
                        };
                        if (uploaded !== null) {
                            uploaded.push(files);
                        } else {
                            uploaded = [];
                            uploaded.push(files);
                        }
                        firebase
                            .database()
                            .ref(`/collections/company_policy`)
                            .set(uploaded, snapshot => {
                                dispatch({
                                    type: VRCORE_UPLOAD_POLICY.SUCCESS
                                });
                                callback({
                                    inProgress: false,
                                    finished: true,
                                    error: false,
                                    msg: "File Successfully Uploaded!"
                                });
                            });
                    });
                }
            );
        } catch (e) {
            console.error(e);
            dispatch({
                type: VRCORE_UPLOAD_POLICY.FAIL
            });
        }
    };
};
export const removeFile = (index, files) => {
    return dispatch => {
        dispatch({
            type: VRCORE_REMOVE_POLICY.REQUEST
        });

        let filename = files[index]["file"];
        try {
            //const index=files.indexOf(i);
            files.splice(index, 1);
            if (files.length === 0) {
                files = null;
            }
            firebase
                .storage()
                .ref(`company_policy/`)
                .child(filename)
                .delete()
                .then(function() {
                    firebase
                        .database()
                        .ref(`/collections/company_policy`)
                        .set(files, snapshot => {
                            dispatch({
                                type: VRCORE_REMOVE_POLICY.SUCCESS
                            });
                        });

                    // File deleted successfully
                })
                .catch(function(error) {
                    // Uh-oh, an error occurred!
                });
        } catch (e) {
            dispatch({
                type: VRCORE_REMOVE_POLICY.FAIL
            });
        }
    };
};
